import { ILLUSTO_API_HOSTNAME } from "../../../config/envConfig";
import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const illustoAPIInstance = APIService({
  baseURL: ILLUSTO_API_HOSTNAME,
});

illustoAPIInstance.interceptors.request.use((config) => {
  if (!config?.skipAuthHeader) {
    config.headers["Authorization"] = LocalStorage.getItem("authToken");
  }

  return config;
});

illustoAPIInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    throw error;
  },
);

export default illustoAPIInstance;
